import React from 'react';
import { Link } from 'react-router-dom';

const Hero = ({ title, subtitle, breadcrumbs, pageName }) => {
  return (
    <div className="container-fluid hero-header">
      <div className="container">
        <div className="row">
          <div className="col-lg-7">
            <div className="hero-header-inner animated zoomIn">
              {subtitle && <p className="fs-4 text-dark">{subtitle}</p>}
              <h1 className="display-1 text-dark">{title}</h1>
              {breadcrumbs && (
                <ol className="breadcrumb mb-0">
                  {breadcrumbs.map((crumb, index) => (
                    <li
                      key={index}
                      className={`breadcrumb-item ${index === breadcrumbs.length - 1 ? 'text-dark' : ''}`}
                      aria-current={index === breadcrumbs.length - 1 ? 'page' : undefined}
                    >
                      {crumb.link ? (
                        <Link to={crumb.link}>{crumb.text}</Link>
                      ) : (
                        crumb.text
                      )}
                    </li>
                  ))}
                </ol>
              )}
              {pageName === 'home' && (
                <Link to="/donate" className="btn btn-primary py-2 px-4">
                  Support Our Masjid
                </Link>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;